<ng-container *ngIf="league.sport.isHockey()">
  <mtg-hockey-game-statistic
    [statistic]="statistic$ | async"
  ></mtg-hockey-game-statistic>
  <mtg-hockey-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-hockey-game-mvp-users>
</ng-container>

<ng-container *ngIf="league.sport.isBasketball()">
  <mtg-basketball-game-statistic
    [statistic]="statistic$ | async"
    [game]="game"
  ></mtg-basketball-game-statistic>
  <mtg-basketball-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-basketball-game-mvp-users>
</ng-container>

<ng-container *ngIf="league.sport.isVolleyball()">
  <mtg-volleyball-game-statistic
    [statistic]="statistic$ | async"
    [game]="game"
  ></mtg-volleyball-game-statistic>
  <mtg-volleyball-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-volleyball-game-mvp-users>
</ng-container>

<ng-container *ngIf="league.sport.isFootball()">
  <mtg-football-game-statistic
    [statistic]="statistic$ | async"
    [game]="game"
  ></mtg-football-game-statistic>
  <mtg-football-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-football-game-mvp-users>
</ng-container>

<ng-container *ngIf="league.sport.isHandball()">
  <mtg-handball-game-statistic
    [statistic]="statistic$ | async"
    [game]="game"
  ></mtg-handball-game-statistic>
  <mtg-handball-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-handball-game-mvp-users>
</ng-container>

<ng-container *ngIf="league.sport.isRugby()">
  <mtg-rugby-game-statistic
    [statistic]="statistic$ | async"
    [game]="game"
  ></mtg-rugby-game-statistic>
  <mtg-rugby-game-mvp-users
    [game]="game"
    [statistic]="userStatistic$ | async"
    [mvpUsers]="mvpUsers$ | async"
  ></mtg-rugby-game-mvp-users>
</ng-container>
